<template>
  <div class="news">
    <template v-for="newsItem in orderedNews">
      <v-news-item :key="newsItem.id" :news-item="newsItem"/>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'news',
    data() {
      return {};
    },
    props: {
      newsItems: {
        type: Array,
      },
    },
    computed: {
      orderedNews() {
        let items = this.newsItems;
        return items.sort((a, b) => {
          return new Date(b.updated_at) - new Date(a.updated_at);
        });
      },
    },
    methods: {},
    components: {
      vNewsItem: () => import('@/components/news-item'),
    },
  };
</script>